// extracted by mini-css-extract-plugin
export default {"container":"SelectedFilters_container__jf7Qy","label":"SelectedFilters_label__fFeWo","more":"SelectedFilters_more__Zg0uE","less":"SelectedFilters_less__YkGUk"};